import { render, staticRenderFns } from "./TabsPage.vue?vue&type=template&id=256ce9a7&"
import script from "./TabsPage.vue?vue&type=script&lang=js&"
export * from "./TabsPage.vue?vue&type=script&lang=js&"
import style0 from "./TabsPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports